import { AfterViewInit, Component, ElementRef, OnInit, ViewChild, ViewContainerRef, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { LtmsEventHandlerService } from '../../services/ltms-event-handler/ltms-event-handler.service';
import { NgClass } from '@angular/common';
@Component({
    selector: 'app-ltms-custom-field-render',
    templateUrl: './ltms-custom-field-render.component.html',
    styleUrls: ['./ltms-custom-field-render.component.scss'],
    imports: [NgClass],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class LtmsCustomFieldRenderComponent implements OnInit, AfterViewInit {
  @ViewChild('vcr', { read: ViewContainerRef }) vcr!: ViewContainerRef;
  @ViewChild('customfieldmodal') customfieldmodal!: ElementRef;
  isModalOpen: boolean = false;
  modalType: string = 'sidebar';

  constructor(private _ltmsEvents:LtmsEventHandlerService) { }
  ngOnInit(): void {
  }
  ngAfterViewInit(): void {
    document.addEventListener('click', (event: any) => {
      if (this.customfieldmodal && this.customfieldmodal.nativeElement !== event.target && !this.customfieldmodal.nativeElement.contains(event.target)) {
        const el:any = document.getElementById('customParameterContainer');
        const isModalVisible = el?.classList?.contains('show');
        this.closeModal()
        if(el){
          el.classList.remove('show') 
          if(isModalVisible){
            this._ltmsEvents.emit('close-custom-field-render')
          }
         
        }

      }
    })
  }
  closeModal() {
    this.isModalOpen = false;
  }

}
